import './App.css';
import SideBar from './components/SideBar';
//pour démarrer l'appli maintenant il faut faire :  react-scripts --openssl-legacy-provider start
import React from "react";

function App() {
  return (
      <SideBar>
      <React.StrictMode>
      </React.StrictMode>
      </SideBar>
  );
}

export default App;
